import { getAuth } from 'firebase/auth'
declare global {
  interface Window {
    getToken:any
  }
}
function setupAuth() {
  window.getToken = () => {
    return getAuth().currentUser?.getIdToken()
  }
}

export { setupAuth }
